import {
  BANKVERIFICATIONSTATUS,
  ExternalPayoutStatus,
  IGetPayoutFacetsResponse,
} from "@shared/lib/types/briefCampains";

export enum PayoutsTab {
  All = "All",
  Pending = "Pending",
  Queued = "Queued",
  Processing = "Processing",
  Paid = "Paid",
  Failed = "Failed",
  Cancelled = "Cancelled",
}

export const PAYOUTS_TABS: PayoutsTab[] = [
  PayoutsTab.All,
  PayoutsTab.Pending,
  PayoutsTab.Queued,
  PayoutsTab.Processing,
  PayoutsTab.Paid,
  PayoutsTab.Failed,
  PayoutsTab.Cancelled,
];

export const ALL_EXTERNAL_PAYOUT_STATUSES: ExternalPayoutStatus[] =
  Object.values(ExternalPayoutStatus);
export const ALL_BANK_VERIFICATION_STATUSES: BANKVERIFICATIONSTATUS[] =
  Object.values(BANKVERIFICATIONSTATUS);

export type PayoutsTabFilters = {
  externalPayoutStatuses: ExternalPayoutStatus[];
  // bankVerificationStatuses: BANKVERIFICATIONSTATUS[];
};

export function getPayoutsTabFilters(tab: PayoutsTab): PayoutsTabFilters {
  // const bankVerificationStatuses = ALL_BANK_VERIFICATION_STATUSES;

  if (tab === PayoutsTab.All) {
    return {
      externalPayoutStatuses: ALL_EXTERNAL_PAYOUT_STATUSES,
      // bankVerificationStatuses,
    };
  }

  if (tab === PayoutsTab.Paid) {
    return {
      externalPayoutStatuses: [ExternalPayoutStatus.Success],
      // bankVerificationStatuses,
    };
  }

  const statusByTab: Record<
    Exclude<PayoutsTab, PayoutsTab.All | PayoutsTab.Paid>,
    ExternalPayoutStatus
  > = {
    [PayoutsTab.Pending]: ExternalPayoutStatus.Pending,
    [PayoutsTab.Queued]: ExternalPayoutStatus.Queued,
    [PayoutsTab.Processing]: ExternalPayoutStatus.Processing,
    [PayoutsTab.Failed]: ExternalPayoutStatus.Failed,
    [PayoutsTab.Cancelled]: ExternalPayoutStatus.Cancelled,
  };

  return {
    externalPayoutStatuses: [statusByTab[tab]],
    // bankVerificationStatuses,
  };
}

export function getPayoutTabCount(
  tab: PayoutsTab,
  facets: IGetPayoutFacetsResponse
): number {
  const counts = facets?.externalPayoutStatus;
  if (!counts) return 0;

  if (tab === PayoutsTab.All) {
    return Object.values(counts).reduce((sum, value) => sum + (value || 0), 0);
  }

  if (tab === PayoutsTab.Paid) {
    return counts.Success ?? 0;
  }

  const countByTab: Record<
    Exclude<PayoutsTab, PayoutsTab.All | PayoutsTab.Paid>,
    number
  > = {
    [PayoutsTab.Pending]: counts.Pending ?? 0,
    [PayoutsTab.Queued]: counts.Queued ?? 0,
    [PayoutsTab.Processing]: counts.Processing ?? 0,
    [PayoutsTab.Failed]: counts.Failed ?? 0,
    [PayoutsTab.Cancelled]: counts.Cancelled ?? 0,
  };

  return countByTab[tab];
}
